export default __webpack_public_path__ + "static/media/WebForensics_WelcomeScreen_Screenshots_Tip3.6dce1d5a.jpg";